export default __webpack_public_path__ + "static/media/B7D9C865-D61F-4806-B175-EAD7761C03A9_1_105_c.9a08bfa0.jpeg";